import CodiceFiscale from 'codice-fiscale-js';
import { userAddressService } from 'libs/api';

export class FiscalCodeHelper {

    static async calculateFiscalCode(user, userProfile) {

        let result = '';

        try {

            const dataPromise = await userAddressService.address(userProfile.bornAddressId);

            const { name, surname } = user;
            const { dob, gender } = userProfile;
            const { city, province, nation, isForeign } = dataPromise.data.payload.address;

            let day = '';
            let month = '';
            let year = '';
            // if dob contains '/' split by '/' and parse italian date else by '-' and parse us date
            if (dob && dob.indexOf('/') > -1) {
                const ddate = dob.split('/');
                day = parseInt(ddate[0]);
                month = parseInt(ddate[1]);
                year = parseInt(ddate[2]);
                
            }else if (dob && dob.indexOf('-') > -1) {
                const ddate = dob.split('-');
                year = parseInt(ddate[0]);
                month = parseInt(ddate[1]);
                day = parseInt(ddate[2]);
            }             
           
            const objFS = {
                name,
                surname,
                gender,
                day,
                month,
                year,
            };

            if (isForeign) {
                objFS.birthplace = nation;
                objFS.birthplaceProvincia = 'EE';
            } else {
                objFS.birthplace = city;
                objFS.birthplaceProvincia = province;
            }
            
            const cf = new CodiceFiscale(objFS);
            result = cf.code;
        }
        catch (error) {
            console.log(error);
        }

        return result;
    }
}